
import { MODULE } from "@/config/modules";
import { ExtraDossiersMetaData } from "@/models/module-extra-dossiers-meta-data";
import { CompanyDossierService } from "@/services/company-dossier-service";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { Company } from "../../models/company";
import { Dossier } from "../../models/dossier";
import { User } from "../../models/user";
import AppDossierNew from "@/components/dossier/DossierNew.vue";
import AppCompanyEditWrapper from "@/components/company/CompanyEditWrapper.vue";

export default Vue.extend({
	data() {
		return {
			selectedRows: [] as Dossier[],
			newDossierModal: false,
			newDossier: new Dossier()
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[] {
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "200px"
				},
				{
					name: "Users",
					property: "users",
					print(users:User[]):string {
						return users.map(u => u.username).join(", ");
					},
					width: "300px"
				},
			];
		},
		editDisabled():boolean {
			return this.selectedRows.length != 1;
		},
		deleteDisabled():boolean {
			return this.selectedRows.length == 0;
		},
		addDisabled():boolean {
			for(let m of this.value.modules){
				if (m.id == MODULE.EXTRA_DOSSIERS){
					let extraCount = ExtraDossiersMetaData.create(m.metaData).getExtraDossiers();
					if (extraCount+1 > this.value.dossiers.length){
						return false;
					}
				}
			}
			return true;
		}
	},
	methods: {
		addClicked() {
			this.newDossierModal = true;
			this.newDossier = new Dossier();
			this.newDossier.companyId = this.value.id;
		},
		editClicked() {
			this.editDossier(this.selectedRows[0]);
		},
		async removeClicked() {
			let confirm = await this.$wf.confirm(`Are you sure you want to delete ${this.selectedRows.length} dossiers?`, "yes", "no");
			if (!confirm) return;
			try{
				for (let dossier of this.selectedRows) {
					await CompanyDossierService.deleteDossier(this.value.id, dossier);
					let i = this.value.dossiers.indexOf(dossier);
					if (i != -1) {
						this.value.dossiers.splice(i, 1);
					}
				}
			}catch(err){}
			this.selectedRows = [];
		},
		editDossier(dossier:Dossier) {
			this.$router.push(`/companies/${this.value.id}/dossier/${dossier.id}/edit`);
		}
	},
	components: {
		AppDossierNew,
		AppCompanyEditWrapper
	}
});
